import { IGroup } from "@fluentui/react";
import { ColumnFiltersState } from "@cayo/shared/components/GridContainer/types/columnFilters";
import { matchesColumnFilters } from "../matchesColumnFilters/matchesColumnFilters";

export const filterGroupedItems = <TItem extends Record<string, unknown>>(
  items: ReadonlyArray<TItem>,
  groups: ReadonlyArray<IGroup>,
  activeColumnFilters: ColumnFiltersState
): { filteredItems: Array<TItem>; filteredGroups: Array<IGroup> } => {
  const filteredItems: Array<TItem> = [];
  const filteredGroups: Array<IGroup> = [];

  let startIndex = 0;

  groups.forEach((group) => {
    const groupItems = items.slice(group.startIndex, group.startIndex + group.count);
    const nextGroupItems = groupItems.filter((item) =>
      matchesColumnFilters(item, activeColumnFilters)
    );

    if (!nextGroupItems.length) {
      return;
    }

    filteredItems.push(...nextGroupItems);
    filteredGroups.push({
      ...group,
      count: nextGroupItems.length,
      startIndex,
    });
    startIndex += nextGroupItems.length;
  });

  return { filteredItems, filteredGroups };
};
